// extracted by mini-css-extract-plugin
export default {"hovering":"Statics_hovering__vGn40","companyLabel":"Statics_companyLabel__SwSSH"};